import { AnalysisConfig } from "@/components/AnalysisConfig/models/AnalysisConfig";
import { AnalysisConfigJsonParsingInputType } from "@/components/AnalysisConfig/services/AnalysisConfigJsonParsingService";
import { IQueueExecutionAnalysisConfigProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { SchemaCoalesceService } from "./SchemaCoalesceService";


export class AnalysisConfigSchemaCoalesceService extends SchemaCoalesceService<AnalysisConfig, AnalysisConfigJsonParsingInputType, IQueueExecutionAnalysisConfigProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<AnalysisConfig, AnalysisConfigJsonParsingInputType>): IQueueExecutionAnalysisConfigProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const config = parsingResult.parsedEntities?.[0];
        if (!config) throw Error("No AnalysisConfig found in parsingResult");

        return config as IQueueExecutionAnalysisConfigProp;
    }

}
